import React, { memo } from 'react';
import { Card, Form } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';

import { BsSearch } from 'react-icons/bs';
import * as _ from 'lodash';
import { colorFix } from 'utils';

import StockSuggest from 'components/select/stockSuggest';
import { makeGetAllStock } from 'lib/selector';

import AnalysisStockOverview from './layout/phan-tich-co-phieu/panel-overview';
import PanelTradeHistory from './layout/phan-tich-co-phieu/panel-trade-his';
import PanelFinacial from './layout/phan-tich-co-phieu/panel-finacial';
import PanelFiles from './layout/phan-tich-co-phieu/panel-files';
import PanelEvents from './layout/phan-tich-co-phieu/panel-events';
import { analStockRealRequest } from 'containers/market/actions';
import { makeGetAnalStockReal } from 'lib/selector';
import PanelNews from './layout/phan-tich-co-phieu/panel-news';
import { makeGetSecAllList } from 'lib/selector';

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function TabAnalysisStock(props) {
  const [tabActive, setTabActive] = React.useState('tong-quan');
  const [symActive, setSymActive] = React.useState('APS');
  const [stockToShow, setStockToShow] = React.useState('APS');

  const dispatch = useDispatch();

  const { symbol, allStock, secListAll, stockDetail, t, theme, algoStock } = props;
  const preSymbol = usePrevious(symbol);
  const preSymActive = usePrevious(symActive);
  const preAlgoStock = usePrevious(algoStock);
  const preStockDetail = usePrevious(stockDetail);

  React.useEffect(() => {
    if (symbol && symbol !== preSymbol) {
      // log(symbol, preSymbol);
      setSymActive(symbol);
    }
  }, [symbol]);

  React.useEffect(() => {
    if (symActive && symActive !== preSymActive) {
      dispatch(analStockRealRequest(symActive));
    }
  }, [symActive]);

  React.useEffect(() => {
    if (stockDetail && !_.isEqual(stockDetail, preStockDetail)) {
      setStockToShow(stockDetail)
    }
  }, [stockDetail]);

  React.useEffect(() => {
    if (algoStock && !_.isEqual(algoStock, preAlgoStock) && algoStock?.CompanyID === stockDetail?.CompanyID) {
      setStockToShow(algoStock)
    }
  }, [algoStock]);

  const _handleAddStock = (stock) => {
    // log(stock);
    setSymActive(stock);
  };

  const _stock =
    symActive && secListAll &&
    symActive !== 'VNINDEX' &&
    secListAll[symActive];

  // log(_stock, stockDetail);

  return (
    <Card className="w-100" style={{ height: 'calc(100vh - 95px)' }}>
      <Card.Header className="d-flex p-0">
        <div
          className="analysis-sym-header mb-0 w-100"
          style={{ padding: '4px 16px', background: theme === 'dark' ? '#1C192C' : '#cacaca' }}
        >
          <Form inline className="form-search position-relative">
            <StockSuggest
              dataSuggest={allStock}
              addStock={_handleAddStock}
              classname={'form-search  text-white form-control fz-14'}
              placeholder={t('algo.ptcp.txt-Search')}
            />
            <BsSearch className="form-add-img" style={{ right: '12px' }} />
          </Form>
          {symActive && (
            <>
              <span className="analysis-sym-item fz-14">{`${_stock}`}</span>
              <span
                className={
                  'analysis-sym-item-detail fz-14 ' +
                  colorFix(
                    stockToShow?.FinishPrice,
                    stockToShow?.RefPrice,
                    stockToShow?.CeilingPrice,
                    stockToShow?.FloorPrice,
                    stockToShow?.RefPrice
                  )
                }
              >{`${stockToShow?.FinishPrice} (${stockToShow?.Diff} ${stockToShow?.DiffRate}%)`}</span>
            </>
          )}
        </div>
      </Card.Header>
      <Card.Body
        className="h-100 d-flex flex-column p-0"
        style={{ background: theme === 'dark' ? 'rgb(2, 2, 16)' : '#ffffff' }}
      >
        <div className="d-flex py-0 pr-2 tabs-cash">
          <a
            className={'fz-14 ' + (tabActive === 'tong-quan' ? 'active' : '')}
            onClick={() => setTabActive('tong-quan')}
          >
            {t('algo.ptcp.txt-overview')}
          </a>
          <a
            className={'fz-14 ' + (tabActive === 'lich-su-gia' ? 'active' : '')}
            onClick={() => setTabActive('lich-su-gia')}
          >
            {t('algo.ptcp.txt-price-history')}
          </a>
          <a
            className={'fz-14 ' + (tabActive === 'tai-chinh' ? 'active' : '')}
            onClick={() => setTabActive('tai-chinh')}
          >
            {t('algo.ptcp.txt-Finance')}
          </a>
          <a
            className={'fz-14 ' + (tabActive === 'ho-so' ? 'active' : '')}
            onClick={() => setTabActive('ho-so')}
          >
            {t('algo.ptcp.txt-Profile')}
          </a>
          <a
            className={'fz-14 ' + (tabActive === 'tin-tuc' ? 'active' : '')}
            onClick={() => setTabActive('tin-tuc')}
          >
            {t('algo.ptcp.txt-News')}
          </a>
          <a
            className={'fz-14 ' + (tabActive === 'su-kien' ? 'active' : '')}
            onClick={() => setTabActive('su-kien')}
          >
            {t('algo.ptcp.txt-Events')}
          </a>
        </div>
        {tabActive === 'tong-quan' && (
          <AnalysisStockOverview
            symbol={symActive}
            setChildSymActive={setSymActive}
            t={t}
            theme={theme}
          />
        )}
        {tabActive === 'lich-su-gia' && (
          <PanelTradeHistory symbol={symActive} t={t} theme={theme}/>
        )}
        {tabActive === 'tai-chinh' && (
          <PanelFinacial symbol={symActive} t={t} theme={theme}/>
        )}
        {tabActive === 'ho-so' && <PanelFiles symbol={symActive} t={t} theme={theme}/>}
        {tabActive === 'tin-tuc' && <PanelNews symbol={symActive} t={t} theme={theme}/>}
        {tabActive === 'su-kien' && <PanelEvents symbol={symActive} t={t} theme={theme}/>}
      </Card.Body>
    </Card>
  );
}

const makeMapStateToProps = () => {
  const getAllStock = makeGetAllStock();
  const getSecAllList = makeGetSecAllList();
  const getAnalStockReal = makeGetAnalStockReal();

  const mapStateToProps = (state) => {
    return {
      allStock: getAllStock(state),
      secListAll: getSecAllList(state),
      stockDetail: getAnalStockReal(state),
      theme: state.client?.setting?.theme === 'light' ? 'light' : 'dark',
      algoStock: state.socket.algoStock,
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(memo(TabAnalysisStock))
);
